/* Mirror existing validation beside the action. This never accepts terms,
   changes validation, transmits a photo or starts a generation. */
(function () {
  'use strict';
  const groups = [
    { buttons: '#add-cart-btn, [data-customizer-mobile-next]', sources: '#upload-trust-line-error, [data-offer-selection-message], #cart-error' },
    { buttons: '#transform-start-btn', sources: '#portrait-photo-error, #portrait-style-error, #portrait-photo-consent-error, #transform-error' },
    { buttons: '#ai-generate-btn', sources: '#ai-error' },
    { buttons: '[data-outfit-submit]', sources: '#outfit-error, #outfit-photo-consent-error' },
    { buttons: '#pq-remaster-btn', sources: '#remaster-photo-consent-error, #pq-error-text' }
  ];
  const visible = node => !!node && !!node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden';
  const bindings = [];
  groups.forEach((group, index) => {
    const sources = [...document.querySelectorAll(group.sources)];
    document.querySelectorAll(group.buttons).forEach((button, position) => {
      const message = document.createElement('p');
      message.id = `cz-action-feedback-${index}-${position}`;
      message.className = 'cz-action-feedback';
      message.hidden = true;
      // Field-level live regions retain announcements; this copy remains
      // available as the action's description without announcing twice.
      message.setAttribute('aria-live', 'off');
      button.before(message);
      const described = (button.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
      button.setAttribute('aria-describedby', [...new Set([...described, message.id])].join(' '));
      bindings.push({ button, message, sources });
    });
  });
  let frame = 0;
  function update() {
    frame = 0;
    bindings.forEach(({ button, message, sources }) => {
      const source = visible(button) && sources.find(node => visible(node) && node.textContent.trim());
      const value = source ? source.textContent.trim() : '';
      if (message.textContent !== value) message.textContent = value;
      if (message.hidden !== !value) message.hidden = !value;
    });
  }
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  const observer = new MutationObserver(schedule);
  // Observe field errors and their containers so successful correction, modal
  // changes and mobile action reparenting clear/reconcile the same feedback.
  document.querySelectorAll('#step-customizer, #transform-modal, #ai-modal, #outfit-match-modal').forEach(root => {
    observer.observe(root, { childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['hidden', 'class', 'style', 'aria-invalid'] });
  });
  window.addEventListener('resize', schedule);
  window.addEventListener('pageshow', schedule);
  update();
})();
